import React, { useCallback, useState } from 'react';

import './styles.scss';
import FormTopUp from './components/FormTopUp';
import { MyButton, MyModal } from 'components/Atoms';
import { FormattedMessage } from 'react-intl';

const ModalTopUp = ({ visible, onClose, checkout, form, listPreviewCards }) => {
  const [loading, setLoading] = useState(false);

  const handleClose = useCallback(() => {
    form.resetFields();
    onClose();
  }, []);

  // balance add payment method

  return (
    <MyModal
      width={700}
      visible={visible}
      onClose={!loading && handleClose}
      title={<FormattedMessage id="wallet_transaction_header.add_funds" defaultMessage="Top Up Balance" />}
      footer={[
        <MyButton
          className="btn-secondary-outline h-45 primary-color min-w-150"
          onClick={!loading && handleClose}
          disabled={loading}
        >
          <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
        </MyButton>,
        <MyButton
          loading={loading}
          type="primary"
          className="btn-primary-custom h-45 min-w-150"
          onClick={form?.submit}
        >
          <FormattedMessage id="wallet_transaction_header.submit_payment" defaultMessage="Submit Payment" />
        </MyButton>,
      ]}
      classNameModal="modal-top-up"
    >
      <FormTopUp
        form={form}
        onClose={handleClose}
        loading={loading}
        setLoading={setLoading}
        checkout={checkout}
        listPreviewCards={listPreviewCards}
      />
    </MyModal>
  );
};

export default ModalTopUp;
